<template>
  <div class="o-account-setup">
    <app-navigation :currentSpace="$t('web.signup.nav_space')"></app-navigation>


    <main class="o-account-setup__main">
      <div
        v-if  = "successMessage === ''"
        class = "c-card js-account-setup-validation-shake"
      >
        <form>
          <div class="c-card__header">
            <h2 class="c-card__title t-headline">{{ $t('web.signup.card_header') }}</h2>
          </div>


          <div class="c-card__body">
            <div class="c-card__paragraph s-html" v-html="signup.text"></div>


            <fieldset class="o-fieldset">
              <label for="primary_email" class="u-label">{{ $t('web.signup.email_label') }}*</label>
              <input
                v-model      = "request.primary_email"
                :class       = "{ 'is-not-valid': errors.primary_email }"
                id           = "primary_email"
                type         = "text"
                placeholder  = ""
                name         = "primary_email"
              />
              <div v-for="error in errors.primary_email">
                <div class="c-validation t-alert-danger">{{ error }}</div>
              </div>
            </fieldset>


            <fieldset class="o-fieldset">
              <label for="first_name" class="u-label">{{ $t('web.signup.first_name_label') }}*</label>
              <input
                v-model      = "request.first_name"
                :class       = "{ 'is-not-valid': errors.first_name }"
                id           = "first_name"
                type         = "text"
                placeholder  = ""
                name         = "first_name"
              />
              <div v-for="error in errors.first_name">
                <div class="c-validation t-alert-danger">{{ error }}</div>
              </div>
            </fieldset>


            <fieldset class="o-fieldset">
              <label class="c-card__subtitle-h3" for="last_name">{{ $t('web.signup.last_name_label') }}*</label>
              <input
                v-model     = "request.last_name"
                :class      = "{ 'is-not-valid': errors.last_name }"
                id          = "last_name"
                type        = "text"
                placeholder = ""
                name        = "last_name"
              />
              <div v-for="error in errors.last_name">
                <div class="c-validation t-alert-danger">{{ error }}</div>
              </div>
            </fieldset>

            <fieldset class="o-fieldset" v-if="showLocales">
              <label class="c-card__subtitle-h3" for="locale">{{ $t('web.signup.locale_label') }}*</label>

              <select

                v-model     = "request.locale"
                id          = "locale"
                text        = "Select locale"
                :class      = "{ 'is-not-valid': errors.last_name }"
                name        = "locale"

                >
                <option v-for="locale in locales" v-bind:value="locale.locale"> {{ locale.name }} </option>
              </select>
            </fieldset>

            <fieldset
              v-for = "field in signup.fields"
              class = "o-fieldset c-card--submit-claim__fieldset"
            >
              <component
                v-model   = "request[field.name]"
                :is       = "getFieldComponentType(field)"
                :field    = "field"
                :errors   = "errors"
                :name     = "field.name"
                className = "c-card__subtitle-h3">
              </component>

              <div v-for="error in errors[field.name]">
                <div class="c-validation t-alert-danger">{{ error }}</div>
              </div>
            </fieldset>
          </div>


          <div class="c-card__footer">
            <button
              :disabled = "processingForm"
              @click    = "submit($event)"
              class     = "c-button c-button--full-width t-button t-button-primary"
            >
             {{ $t('web.signup.signup_button_text') }}
            </button>
          </div>
        </form>
      </div>


      <div v-else class="c-card js-account-setup-validation-shake">
        <div class="c-card__header">
          <h2 class="c-card__title t-headline">{{ $t('web.signup.card_header') }}</h2>
        </div>

        <div class="c-card__body u-margin-bottom-15 u-margin-top-15">
          <div class="c-card__paragraph s-html" v-html="successMessage"></div>
        </div>

        <div class="c-card__footer">
        </div>
      </div>
    </main>


    <app-footer></app-footer>
  </div>
</template>




<script>
import $ from 'jquery'
import _ from 'lodash'
import util from '@/functions'
import { mapActions, mapGetters } from 'vuex'
import FieldCurrency from '@/views/components/fields/FieldCurrency'
import FieldVarchar from '@/views/components/fields/FieldVarchar'
import FieldEmail from '@/views/components/fields/FieldEmail'
import FieldDate from '@/views/components/fields/FieldDate'
import FieldDecimal from '@/views/components/fields/FieldDecimal'
import FieldInteger from '@/views/components/fields/FieldInteger'
import FieldPercent from '@/views/components/fields/FieldPercent'
import FieldBool from '@/views/components/fields/FieldBool'
import FieldEnum from '@/views/components/fields/FieldEnum'
export default {
  name: 'signup',
  data () {
    return {
      successMessage: '',
      processingForm: false,
      request: {
        primary_email: null,
        first_name: null,
        last_name: null
      },
      errors: {
        primary_email: null,
        first_name: null,
        last_name: null
      },
      signup: {
        text: '',
        fields: [],
        confirmation: ''
      },
      dataToBeSaved: {},
      locales: [],
      showLocales: false
    }
  },
  components: {
    fieldCurrency: FieldCurrency,
    fieldVarchar: FieldVarchar,
    fieldEmail: FieldEmail,
    fieldDate: FieldDate,
    fieldDecimal: FieldDecimal,
    fieldInteger: FieldInteger,
    fieldPercent: FieldPercent,
    fieldBool: FieldBool,
    fieldEnum: FieldEnum
  },
  computed: {
    ...mapGetters({
      websiteConfig: 'websiteConfig'
    })
  },
  mounted () {
    this.$store.dispatch('GET_WEBSITE_CONFIG')
      .then((resp) => {
        if (!resp.data.websiteConfig.enrollment_enabled) {
          this.$router.push({ name: 'NotFound' })
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.$router.push({ name: 'NotFound' })
        }
      })
    this.signup = this.websiteConfig.signup
      // create a reactive array of values and error messages for each field
    _.each(this.signup.fields, (item) => {
      this.$set(this.errors, item.name, null)
      this.$set(this.request, item.name, null)
    })

    this.locales = this.websiteConfig.locales

    if (this.locales.length > 1) {
      this.showLocales = true
    }
  },
  methods: {
    ...mapActions(['SIGN_UP']),
    submit (e) {
      e.preventDefault()
      this.errors = {}
      if (this.validateForm()) {
        this.dataToBeSaved = util.getDataToBeSaved(this.signup.fields, this.request)
        for (var attr in this.request) {
          if (typeof this.dataToBeSaved[attr] === 'undefined') {
            this.dataToBeSaved[attr] = this.request[attr]
          }
        }
        this.dataToBeSaved.platform_id = this.websiteConfig.id
        this.processingForm = true
        this.request.platform_id = this.websiteConfig.id
        this.SIGN_UP(this.dataToBeSaved)
        .then((resp) => {
          this.successMessage = this.signup.confirmation
          this.processingForm = false
        })
        .catch((err) => {
          if (err.response && err.response.status === 400) {
            this.errors = util.handleResponseErrors(this.$el, err.response.data.errors)
          }
          if (err.response && err.response.status === 403) {
            this.websiteConfig.enrollment_enabled = false
            this.$store.commit('UPDATE_WEBSITE_CONFIG', this.websiteConfig)
            this.successMessage = this.$t('web.signup.enrollment_unavailable')
          }
          this.processingForm = false
        })
      } else {
        util.shake($('.js-account-setup-validation-shake'))
      }
    },
    validateForm () {
      var standardFields = ['primary_email', 'first_name', 'last_name']
      var validation =
        util.validateForm(this.$el, standardFields, this.signup.fields, this.request, this.validationConstraints(), {fullMessages: false})
      this.errors = validation.errors
      return validation.valid
    },
    validationConstraints () {
      return {
        primary_email: {
          presence: {message: this.$t('web.signup.email_required')},
          email: {message: this.$t('web.signup.email_invalid')}
        },
        first_name: {
          presence: {message: this.$t('web.signup.first_name_required')}
        },
        last_name: {
          presence: {message: this.$t('web.signup.last_name_required')}
        }
      }
    },
    getFieldComponentType (field) {
      return 'field-' + _.replace(field.type, '_', '-')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Signup.vue?13d742d8